export enum productOptionActionsTypes {
  GET_PRODUCT_OPTION_REQUEST = 'GET_PRODUCT_OPTION_REQUEST',
  GET_PRODUCT_OPTION_SUCCESS = 'GET_PRODUCT_OPTION_SUCCESS',
  GET_PRODUCT_OPTION_FAILURE = 'GET_PRODUCT_OPTION_FAILURE',
}
